/**
 * Convert any YouTube URL or 11-char ID to an embeddable URL.
 * Returns null if the input is not parseable as YouTube.
 */
export function ytEmbedUrl(input) {
  if (!input) return null;
  const s = String(input).trim();
  // Plain ID (11 chars, A-Z/a-z/0-9/_/-)
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return `https://www.youtube.com/embed/${s}`;
  // youtu.be/<id>
  let m = s.match(/youtu\.be\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  // youtube.com/watch?v=<id>
  m = s.match(/[?&]v=([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  // youtube.com/shorts/<id>
  m = s.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  // youtube.com/embed/<id>
  m = s.match(/youtube\.com\/embed\/([A-Za-z0-9_-]{11})/);
  if (m) return `https://www.youtube.com/embed/${m[1]}`;
  return null;
}

/** YouTube thumbnail (hqdefault works without API key). */
export function ytThumb(input) {
  const url = ytEmbedUrl(input);
  if (!url) return null;
  const m = url.match(/embed\/([A-Za-z0-9_-]{11})/);
  if (!m) return null;
  return `https://i.ytimg.com/vi/${m[1]}/hqdefault.jpg`;
}

/** Convert any Vimeo URL or numeric ID to an embeddable URL. */
export function vimeoEmbedUrl(input) {
  if (!input) return null;
  const s = String(input).trim();
  if (/^\d{6,12}$/.test(s)) return `https://player.vimeo.com/video/${s}`;
  const m = s.match(/vimeo\.com\/(?:video\/)?(\d{6,12})/);
  if (m) return `https://player.vimeo.com/video/${m[1]}`;
  return null;
}

/** Estimate read-time in minutes from a string of HTML/text. 200 wpm. */
export function estimateReadTime(text) {
  if (!text) return 1;
  const words = String(text).replace(/<[^>]*>/g, " ").split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / 200));
}
